import { render, staticRenderFns } from "./BamboraDirectDebitForm.vue?vue&type=template&id=18aa1472&"
import script from "./BamboraDirectDebitForm.vue?vue&type=script&lang=js&"
export * from "./BamboraDirectDebitForm.vue?vue&type=script&lang=js&"
import style0 from "./BamboraDirectDebitForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports